import React, { useEffect, useState } from "react";
import ClientLayout from "../../components/client/ClientLayout";
import { useAuth } from "../../context/AuthContext";
import { clientApi } from "../../api";
import { getToken } from "../../utils/authStorage";
import PasswordInput from "../../components/PasswordInput";

export default function Profile() {
  const { user, login } = useAuth();
  const [me, setMe] = useState(null);
  const [name, setName] = useState("");
  const [savingName, setSavingName] = useState(false);
  const [nameError, setNameError] = useState("");
  const [nameSuccess, setNameSuccess] = useState("");

  // Password change
  const [pwForm, setPwForm] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [pwError, setPwError] = useState("");
  const [pwSuccess, setPwSuccess] = useState("");
  const [pwLoading, setPwLoading] = useState(false);

  useEffect(() => {
    clientApi.getMe().then((m) => { setMe(m); setName(m.name || ""); }).catch(() => {});
  }, []);

  async function saveName() {
    setSavingName(true); setNameError(""); setNameSuccess("");
    try {
      await clientApi.updateMe({ name });
      const token = getToken("client");
      login({ ...user, name }, token);
      setNameSuccess("Name saved.");
      setTimeout(() => setNameSuccess(""), 2500);
    } catch (err) { setNameError(err.message); }
    setSavingName(false);
  }

  async function changePassword(e) {
    e.preventDefault();
    setPwError(""); setPwSuccess("");
    if (pwForm.newPassword !== pwForm.confirmPassword) return setPwError("Passwords don't match");
    if (pwForm.newPassword.length < 6) return setPwError("Password must be at least 6 characters");
    setPwLoading(true);
    try {
      await clientApi.changeSelfPassword(pwForm.currentPassword, pwForm.newPassword);
      setPwSuccess("Password changed successfully");
      setPwForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) { setPwError(err.message); }
    setPwLoading(false);
  }

  return (
    <ClientLayout>
      <div className="venues-page-header">
        <div>
          <h1>My Profile</h1>
          <p className="page-subtitle">Your account details and password</p>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: "1rem", maxWidth: 900 }}>
        <div className="settings-card">
          <div className="settings-card-header"><h3>Account</h3><p>Your email and display name</p></div>
          {nameError && <div className="toast toast-error" style={{ marginBottom: "0.75rem" }}>{nameError}</div>}
          {nameSuccess && <div className="toast toast-success" style={{ marginBottom: "0.75rem" }}>{nameSuccess}</div>}
          {!me ? (
            <div className="muted">Loading…</div>
          ) : (
            <>
              <div className="form-field">
                <label htmlFor="profile-email">Email</label>
                <input id="profile-email" value={me?.email || ""} disabled />
              </div>
              <div className="form-field">
                <label htmlFor="profile-role">Role</label>
                <input id="profile-role" value={me?.clientRole || ""} disabled style={{ textTransform: "capitalize" }} />
              </div>
              <div className="form-field">
                <label htmlFor="profile-name">Display name</label>
                <input id="profile-name" value={name} onChange={(e) => setName(e.target.value)} />
              </div>
              <button className="btn btn-primary" onClick={saveName} disabled={savingName}>{savingName ? "Saving…" : "Save"}</button>
            </>
          )}
        </div>

        <div className="settings-card">
          <div className="settings-card-header"><h3>Change Password</h3><p>Update your account password</p></div>
          {pwError && <div className="toast toast-error" style={{ marginBottom: "0.75rem" }}>{pwError}</div>}
          {pwSuccess && <div className="toast toast-success" style={{ marginBottom: "0.75rem" }}>{pwSuccess}</div>}
          <form onSubmit={changePassword}>
            <div className="form-field">
              <label>Current Password <span className="required">*</span></label>
              <PasswordInput value={pwForm.currentPassword} onChange={(e) => setPwForm({ ...pwForm, currentPassword: e.target.value })} required />
            </div>
            <div className="form-field">
              <label>New Password <span className="required">*</span></label>
              <PasswordInput value={pwForm.newPassword} onChange={(e) => setPwForm({ ...pwForm, newPassword: e.target.value })} required />
            </div>
            <div className="form-field">
              <label>Confirm New Password <span className="required">*</span></label>
              <PasswordInput value={pwForm.confirmPassword} onChange={(e) => setPwForm({ ...pwForm, confirmPassword: e.target.value })} required />
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={pwLoading}>{pwLoading ? "Updating…" : "Update Password"}</button>
          </form>
        </div>
      </div>
    </ClientLayout>
  );
}
